import { Actions } from "../actions/types";

const initialState = {
  token: null,
  status: "idle",
  items: [],
  item_count: 0,
  total_cents: 0,
  total_display: "",
  customer_name: "",
  customer_email: "",
  customer_phone: "",
  notes: "",
  payment_method: "",
  payment_reference: "",
  delivery_method: "",
  shipping_name: "",
  shipping_address1: "",
  shipping_address2: "",
  shipping_city: "",
  shipping_state: "",
  shipping_postcode: "",
  shipping_country: "",
  submitted_at: null,
  created_at: null,
  updated_at: null,
  loading: false,
  error: null,
  lastAction: null,
  checkoutSuccess: false,
};

const mapCartPayload = (payload = {}) => ({
  token: payload.token || null,
  status: payload.status || "active",
  items: Array.isArray(payload.items) ? payload.items : [],
  item_count: payload.item_count || 0,
  total_cents: payload.total_cents || 0,
  total_display: payload.total_display || "",
  customer_name: payload.customer_name || "",
  customer_email: payload.customer_email || "",
  customer_phone: payload.customer_phone || "",
  notes: payload.notes || "",
  payment_method: payload.payment_method || "",
  payment_reference: payload.payment_reference || "",
  delivery_method: payload.delivery_method || "",
  shipping_name: payload.shipping_name || "",
  shipping_address1: payload.shipping_address1 || "",
  shipping_address2: payload.shipping_address2 || "",
  shipping_city: payload.shipping_city || "",
  shipping_state: payload.shipping_state || "",
  shipping_postcode: payload.shipping_postcode || "",
  shipping_country: payload.shipping_country || "",
  submitted_at: payload.submitted_at || null,
  created_at: payload.created_at || null,
  updated_at: payload.updated_at || null,
});

export default function cart(state = initialState, action) {
  switch (action.type) {
    case Actions.CART_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        lastAction: action.meta?.action || null,
        checkoutSuccess: false,
      };

    case Actions.CART_SET: {
      const mapped = mapCartPayload(action.payload);
      return {
        ...state,
        ...mapped,
        loading: false,
        error: null,
        checkoutSuccess: false,
      };
    }

    case Actions.CART_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload || "Unable to update cart.",
        lastAction: action.meta?.action || state.lastAction,
      };

    case Actions.CART_CLEAR:
      return {
        ...initialState,
      };

    case Actions.CART_CHECKOUT_SUCCESS: {
      const mapped = mapCartPayload(action.payload);
      return {
        ...state,
        ...mapped,
        loading: false,
        error: null,
        checkoutSuccess: true,
      };
    }

    default:
      return state;
  }
}
